import { RefObject, useEffect, useState } from 'react';

export const useContentOverflow = (ref: RefObject<HTMLInputElement | null>) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = ref.current;
    !!element &&
      element.scrollWidth > element.clientWidth &&
      setIsOverflowing(true);
  }, [ref]);

  return isOverflowing;
};
